export const tracksUnavailableHeadline = (unavailable: boolean): string =>
  unavailable ? 'Not on your Advanced caseload' : 'Advanced is not responding'
